// extracted by mini-css-extract-plugin
export var content = "footer-module--content--3jIbB";